interface AppFooterProps {
  visible: boolean;
}

export function AppFooter({ visible }: AppFooterProps) {
  return (
    <footer className="footer">
      <div
        className="footer__instruction"
        style={{ opacity: visible ? 1 : 0 }}
        aria-hidden={!visible}
      >
        <span>Appuyez sur le bouton <span className="keycap">1</span> , <span className="keycap">2</span> ou <span className="keycap">3</span> pour répondre</span>
      </div>
      <div className="footer__campaign">NETTOYAGE TOUT-EN-UN</div>
    </footer>
  );
}
